import { lazy } from 'react';

const Category = lazy(() => import('./Category'));

export default Category;
